module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./BirthdayVideoView.js"));
	}, "BirthdayVideoView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BirthdayVideoView!./src/pages/Share/BirthdayVideo/BirthdayVideoView.js
// module id = 1175
// module chunks = 438